/**
 * How a measured value reads on screen, in the unit its benchmark was set in.
 * Mirrors formatMeasure in server/services/coa/monitoringEngine.js, so the
 * grid, the modal, Charting and the PDF all say "2:00" for a 120 second
 * call-center standard and "95%" for a timeliness rate — never "120%".
 */
export const UNIT_WORDS = {
  percent: { label: 'Percent', suffix: '%', delta: ' pts' },
  seconds: { label: 'Seconds', suffix: ' sec', delta: ' sec' },
  minutes: { label: 'Minutes', suffix: ' min', delta: ' min' },
  hours: { label: 'Hours', suffix: ' hr', delta: ' hr' },
  days: { label: 'Days', suffix: ' days', delta: ' days' },
  count: { label: 'Count', suffix: '', delta: '' },
};

export function normalizeUnit(unit) {
  return UNIT_WORDS[unit] ? unit : 'percent';
}

export function fmtMeasure(v, unit = 'percent') {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return '—';
  const n = Number(v);
  const u = normalizeUnit(unit);
  if (u === 'seconds') {
    const s = Math.round(n);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
  }
  const plural = (x, word) => { const r = Math.round(x * 100) / 100; return `${r} ${word}${r === 1 ? '' : 's'}`; };
  if (u === 'minutes') return plural(n, 'minute');
  if (u === 'hours') return plural(n, 'hour');
  if (u === 'days') return plural(n, 'day');
  if (u === 'count') return String(Math.round(n));
  return `${Math.round(n * 10) / 10}%`;
}

/** The word for a change between two periods: "pts" for rates, the unit otherwise. */
export function deltaSuffix(unit = 'percent') {
  return UNIT_WORDS[normalizeUnit(unit)].delta;
}

/** The unit an activity or feed row measures in: its own, then its series', then percent. */
export function unitOf(row) {
  if (!row) return 'percent';
  const fromMetric = Array.isArray(row.metrics) && row.metrics.find((m) => m && m.unit)?.unit;
  return normalizeUnit(row.metrics_summary?.unit || fromMetric || row.series_benchmark_unit || row.benchmark_unit || 'percent');
}
